module.exports = "https://trybtryb-legacy.web.app/img/square-mobile.f034deb3.svg";